import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-430702d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-plus" }, null, -1))
const _hoisted_3 = { class: "text-[12px]" }

import { IncrediButton } from 'incredi-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'addEntityBtn',
  props: {
    buttonTitle: null,
    addNewBuildGroup: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediButton), {
    class: "cloud-button",
    "data-testid": "add-build-group-btn",
    design: "primary-black",
    size: "small",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.addNewBuildGroup()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.buttonTitle), 1)
      ])
    ]),
    _: 1
  }))
}
}

})